import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import classes from './deleteConfirmationModalLVTime.module.scss';

interface DeleteConfirmationModalLvTimeProps {
  visible: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationModalLvTime = ({
  visible,
  onHide,
  onConfirm
}: DeleteConfirmationModalLvTimeProps) => {
  return (
    <Dialog
      header="Delete This Row?"
      visible={visible}
      onHide={onHide}
      className={classes.modal}
      style={{ width: '450px' }}
    >
      <p>Are you sure you want to delete this row?</p>

      <div className={classes.modalFooter}>
        <Button label="Close" className="p-button-text" onClick={onHide} />
        <Button label="Yes, I'm Sure" className={classes.confirmButton} onClick={onConfirm} />
      </div>
    </Dialog>
  );
};

export default DeleteConfirmationModalLvTime;
